module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NDAiIGhlaWdodD0iMjU0IiB2aWV3Qm94PSIwIDAgNTQwIDI1NCI+PHJlY3Qgd2lkdGg9IjUzOSIgaGVpZ2h0PSIyNTMuMTA1IiB4PSIxMTguMzI3IiB5PSI1MTE1IiBmaWxsPSIjRTlFMUY5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHJ4PSI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE4IC01MTE1KSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/drive-bg.svg
// module id = 1AVU
// module chunks = 0